import config from '../config/api';
import logger from '../logging/logger';

interface SyncUserResponse {
  success: boolean;
  message: string;
  data?: {
    user?: {
      uuid: string;
      email: string;
      username: string;
    };
    waitlist_approved?: boolean;
  };
}

export async function syncAuth0User(
  email: string,
  username: string,
  auth0Sub: string
): Promise<SyncUserResponse> {
  logger.info('🔄 Syncing Auth0 user to database...', { email, username, auth0Sub });
  
  try {
    const response = await fetch(`${config.apiUrl}/sync_auth0_user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        username,
        auth0_sub: auth0Sub
      })
    });

    logger.info('📡 Sync response status:', response.status);
    const data = await response.json();
    logger.info('📡 Sync response data:', data);
    
    if (!response.ok) {
      logger.error('❌ User sync failed:', data);
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }

    logger.info('✅ User sync successful:', data);
    return data;
  } catch (error) {
    logger.error("❌ User sync error:", error);
    throw error;
  }
}

export async function checkWaitlistStatus(email: string): Promise<boolean> {
  try {
    const response = await fetch(`${config.apiUrl}/waitlist/status?email=${encodeURIComponent(email)}`);
    if (!response.ok) return false;
    const data = await response.json();
    return data.approved === true;
  } catch {
    return false;
  }
}

export async function verifyInviteCode(email: string, code: string): Promise<boolean> {
  try {
    const response = await fetch(`${config.apiUrl}/waitlist/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, code }),
    });
    return response.ok;
  } catch {
    return false;
  }
}
